import './authHelpers';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';
const API_URL = `${API_BASE}/financiero`;

// Configurar axios para incluir el token de autenticación
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Conceptos de Cobro CRUD
export const getConceptosCobro = async (params = {}) => {
  const { search, campus, estado, ciclo, aplicacion, ordering, page, page_size } = params;
  let url = `${API_URL}/billing-concepts/`;
  const query = [];
  if (search) query.push(`search=${encodeURIComponent(search)}`);
  if (campus) query.push(`campus=${campus}`);
  if (estado !== undefined && estado !== '') query.push(`estado=${encodeURIComponent(estado)}`);
  if (ciclo) query.push(`ciclo=${encodeURIComponent(ciclo)}`);
  if (aplicacion) query.push(`aplicacion=${encodeURIComponent(aplicacion)}`);
  if (ordering) query.push(`ordering=${encodeURIComponent(ordering)}`);
  if (page) query.push(`page=${page}`);
  if (page_size) query.push(`page_size=${page_size}`);
  if (query.length) url += `?${query.join('&')}`;
  const res = await axios.get(url);
  return res.data;
};

export const getConceptoCobro = async (id) => {
  const res = await axios.get(`${API_URL}/billing-concepts/${id}/`);
  return res.data;
};

export const createConceptoCobro = async (data) => {
  const res = await axios.post(`${API_URL}/billing-concepts/`, data);
  return res.data;
};

export const updateConceptoCobro = async (id, data) => {
  const res = await axios.put(`${API_URL}/billing-concepts/${id}/`, data);
  return res.data;
};

export const patchConceptoCobro = async (id, data) => {
  const res = await axios.patch(`${API_URL}/billing-concepts/${id}/`, data);
  return res.data;
};

export const deleteConceptoCobro = async (id) => {
  const res = await axios.delete(`${API_URL}/billing-concepts/${id}/`);
  return res.data;
};

// Duplicar concepto de cobro
export const duplicateConceptoCobro = async (id, data = {}) => {
  const res = await axios.post(`${API_URL}/billing-concepts/${id}/duplicar/`, data);
  return res.data;
};

// Campus dropdown
export const getCampusDropdown = async () => {
  const res = await axios.get(`${API_URL}/campus-dropdown/`);
  return res.data;
};

// Ciclos escolares dropdown
export const getCycles = async () => {
  const res = await axios.get(`${API_URL}/ciclos-dropdown/`);
  return res.data;
};
